import React from 'react';
import './Home.css';

export const Home = () => {
	return (
		<section className='full-height-container home-background' id='home'>
		</section>
	);
}